export class CollectionModel {
  constructor() {
    this.id = 0;
    this.agencyId = 0;
    this.name = '';
    this.coverUrl = '';
    this.content = '';
  }
}
